import axios from 'axios';
import { customHistory } from 'src/components/CustomRouter';
import i18n from 'src/i18n/i18n';

const ROUTES = {
    //BASE: 'http://10.169.3.25:2210',
    //BASE: 'http://10.169.3.25:8083',
    //BASE: 'http://127.0.0.1:8000',
    BASE: 'https://citassspe.chihuahua.gob.mx',
    CONFIGURATION_ADDRESSES_UPLOAD: '/api/configurations-addresses',
    LICENCE_TYPES_RESOURCE: '/api/licence-types',
    MODULES_RESOURCE: '/api/modules',
    FORMALITIES_RESOURCE: '/api/formalities',
    IDENTIFICATIONS_RESOURCE: '/api/identifications',
    ADDRESS_VERIFICATION_DOCUMENTS_RESOURCE: '/api/address-verification-documents',
    NATIONALITIES_RESOURCE: '/api/nationalities',

    MUNICIPALITIES_FOR_SELECT: '/api/municipalities-for-select',
    SELECTS_DATA: '/api/appointments-form-selects-data',
    CALENDAR_AVAILABLE_DATES: '/api/appointment/calendar',
    GENERATE_APPOINTMENT: '/api/appointment',

    CANCEL_APPOINTMENT: '/api/appointment/cancel',
    DATES_AVAILABILITY: "/api/dates-availability",
    DATES_AVAILABILITY_SELECTS_DATA: '/api/dates-availability-selects-data',
    CITIZENS_RESOURCE: '/api/citizens',
    APPOINTMENTS: '/api/appointments',
    NONWORKING_DAYS_RESOURCE: '/api/nonworking-days',

    CHANGE_LOGS_RESOURCE: '/api/change-log',

    DATES_AVAILABILITY_EXCEPTION: "/api/dates-availability-exception",
    DATES_AVAILABILITY_EXCEPTION_SELECTS_DATA: '/api/dates-availability-exception-selects-data',

    RESET_PASSWORD: "/api/admin/reset-password",

    VERIFY_HS_ENROLLMENT: "/api/highschool/verify",
    GET_HIGHSCHOOLS: "/api/highschool/get/highschools",

    HG_APPOINTMENT: "/api/highschool/appointment",
}

let onUnauthenticatedCallback;

const http = axios.create({
    baseURL: ROUTES.BASE,
    headers: {
        "X-requested-With": "XMLHttpRequest",
    },
    withCredentials: true,
});

http.interceptors.response.use(
    (response) => Promise.resolve(response.data),
    (error) => {
        if (axios.isCancel(error)) {
            return Promise.reject(error);
        }

        switch (error.response.status) {
            case 403:
                if (error.response.data.exception !== 'Illuminate\\Routing\\Exceptions\\InvalidSignatureException') {
                    customHistory.push('/status/403');
                }
                break;

            case 401:
                onUnauthenticatedCallback();
                throw new axios.Cancel(i18n.t('STATUS.401.MESSAGE'));

            default:
                break;
        }
        return Promise.reject((error.response && error.response.data) || error);
    }
);

const downloadAppointmentsExcel = (url, params) => {
    return http.get(url, { responseType: 'blob', params }).then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        let filename = 'Citas.xlsx';
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    });
}

const setUnauthenticatedCallback = (onUnauthenticatedCallbackFn: Function) => {
    onUnauthenticatedCallback = onUnauthenticatedCallbackFn;
}

const rebuildData = (values, edit = false) => {
    let formData = new FormData();
    Object.keys(values).forEach(key => {
        if (values[key]) {
            if (Array.isArray(values[key])) {
                values[key].forEach(element => {
                    formData.append(key + '[]', element);
                });
            } else {
                formData.append(key, values[key]);
            }
        }
    });
    if (edit) {
        formData.append('_method', 'PUT');
    }
    return formData;
};

export default http;
export { downloadAppointmentsExcel, ROUTES, setUnauthenticatedCallback, rebuildData };
